import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { 
  AppHeaderBox, 
  AppInfoContainer, 
  AppName, 
  AppDescription, 
  ButtonContainer, 
  LogoSkeleton, 
  PrimaryButtonSkeleton, 
  SecondaryButtonSkeleton, 
  CustomerServiceSkeleton 
} from '../styles/AppDetails'; 
import { useTranslation } from 'react-i18next';

const AppHeaderSkeleton = ({ isRtl }: { isRtl: boolean }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <AppHeaderBox>
      <LogoSkeleton>
        <Skeleton width="100%" height="100%" borderRadius={8} />
      </LogoSkeleton>
      
      <AppInfoContainer>
        <AppName as="div">
          <Skeleton width={200} height={22} />
        </AppName>
        
        <AppDescription as="div">
          <Skeleton count={2} width="100%" height={16} />
        </AppDescription>
        
        <ButtonContainer>
          <PrimaryButtonSkeleton isRtl={isRtl}>
            <Skeleton width="100%" height="100%" borderRadius={8} />
          </PrimaryButtonSkeleton>
          
          <SecondaryButtonSkeleton isRtl={isRtl}>
            <Skeleton width="100%" height="100%" borderRadius={8} />
          </SecondaryButtonSkeleton>
          
          <CustomerServiceSkeleton>
            <Skeleton width="100%" height="100%" />
          </CustomerServiceSkeleton>
        </ButtonContainer>
      </AppInfoContainer>
    </AppHeaderBox>
  );
};

export default AppHeaderSkeleton;
